import { OnboardingChat } from "@/components/onboarding/onboarding-chat";
import { OnboardingShell } from "@/components/onboarding/shell";

export default function OnboardingPage() {
  return (
    <OnboardingShell>
      <OnboardingChat />
    </OnboardingShell>
  );
}
